import React, { useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { LoadingSpinner } from "../../../../common/Loading";
import LeaveRecallModule from "./LeaveRecallModule"; // MODIFIED: Corrected Import
import { useLeaveRecall } from "../../../hooks/useLeaveRecall"; // ADDED
import LeaveRecallHistory from "./components/LeaveRecallHistory";

function LeaveRecallTab({ user, userAccess, showGeneralMessage }) {
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const currentEmployeePersonalInformationId = user?.employeePersonalInformationId;

  // MODIFIED: Using the specific Recall hook
  const {
    loading,
    recallableData,
    recallHistory,
    submitRecall
  } = useLeaveRecall({
    employeePersonalInformationId: currentEmployeePersonalInformationId,
    showGeneralMessage: showGeneralMessage
  });

  return (
    <>
      <div className="v2-module-container">
        {/* Header */}
        <div className="mainteHeader p-4 border-b flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold">Leave Recall</h3>
          </div>

          <button
            onClick={() => setShowHistoryModal(true)}
            className="flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md border-none cursor-pointer transition-colors shadow-sm font-medium"
          >
            <RemoveRedEyeIcon fontSize="small" className="mr-2" />
            RECALL HISTORY
          </button>
        </div>

        {/* MODIFIED: Passing recall-specific data */}
        <LeaveRecallModule
          user={user}
          data={recallableData}
          loading={loading}
          onRecall={submitRecall}
        />
      </div>

      {/* Reusing existing history modal for recall history */}
      <LeaveRecallHistory
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        data={recallHistory || []}
      />

      <LoadingSpinner loading={loading} />
    </>
  );
}

export default LeaveRecallTab;